import SignalContent from "../signal_content";
import { RequestSignallampParamsMaker } from "./make_signallamp_request_params";
import axios from "axios";
import CognitoController from "../../../common/scripts/cognito_controller";

export async function getSignallampSetting(self: SignalContent) {
  try {
    const userID: string = self.userID;
    await CognitoController.refreshToken();
    const requestParams: object = RequestSignallampParamsMaker.makeGetSignallampSettingDataParams(
      self,
      userID,
    );
    const apiResponse: any = await axios(requestParams);
    // userIDとsignallamp_idが一致するものは必ず一意
    if (self.selectDeviceId) {
      for (const key in apiResponse.data.res.mst_signallamp_setting) {
        if (self.selectDeviceId === apiResponse.data.res.mst_signallamp_setting[key].device_id) {
          self.mstSignallampSetting = apiResponse.data.res.mst_signallamp_setting[key];
        }
      }
    } else {
      self.mstSignallampSetting = apiResponse.data.res.mst_signallamp_setting[0];
    }
    // ユーザに紐づく認証情報を取得
    self.authStores = apiResponse.data.res.auth_stores;
    return apiResponse;
  } catch (e) {
    console.error(e);
    alert(self.$t("message.failedToRetrieveSettings"));
  }
}
